import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
// @mui
import { Collapse } from '@mui/material';
// hooks
import useActiveLink from '../../../hooks/useActiveLink';
//
import NavItem from './NavItem';
import AppCache from '../../../services/appcache';
// ----------------------------------------------------------------------

NavList.propTypes = {
    data: PropTypes.object,
    depth: PropTypes.number,
    hasChild: PropTypes.bool,
};

export default function NavList({ data, depth, hasChild }) {
    const { pathname } = useLocation();
    const path = pathname.split('/')[2];
    const safePath = typeof data?.path === "string" ? data.path : "";
    const { active, isExternalLink } = useActiveLink(safePath);
    const openinnewtab = data?.opneinnewtab || false;

    const [open, setOpen] = useState(active);

    useEffect(() => {
        if (!active) {
            handleClose();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [path]);

    const handleToggle = () => {
        setOpen(!open);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <>
            <NavItem
                item={data}
                depth={depth}
                open={open}
                active={active}
                isExternalLink={openinnewtab || isExternalLink}
                onClick={handleToggle}
            />

            {hasChild && (
                <Collapse in={open} unmountOnExit>
                    <NavSubList data={data.children} depth={depth} />
                </Collapse>
            )}
        </>
    );
}

// ----------------------------------------------------------------------

NavSubList.propTypes = {
    data: PropTypes.array,
    depth: PropTypes.number,
};

function NavSubList({ data, depth }) {

    // const franchise = AppCache?.GetEmpTerritory().Franchise;
    const restrictedFranchises = ['ETHICON', 'ENDO', 'BW'];
    // const filteredData = data.filter(item => !(restrictedFranchises.includes(franchise.toUpperCase()) && item.title === "Surgeons"));

    const franchise = AppCache?.GetUserLoginDetails()?.Franchise;
    const franchiseList = franchise?.split(',').map(f => f.trim().toUpperCase());
    const hasNonRestricted = franchiseList?.some(f => !restrictedFranchises.includes(f));
    const filteredData = hasNonRestricted ? data : data?.filter(item => item.title !== "Surgeons");

    return (
        <>
            {filteredData.map((list) => (
                <NavList
                    key={list.title + list.path}
                    data={list}
                    depth={depth + 1}
                    hasChild={!!list.children}
                />
            ))}
        </>
    );
}
